import { useEffect, useState } from 'react';

/**
 * Hook to determine if the web app is running inside a (Android or iOS) WebView that's configured with
 * a native communication bridge. Fallback check is the user agent string. There is no standard API to
 * detect a web app running inside a WebView.
 *
 * The primary use case is for hiding the global header and nav bar for the mobile app when it runs the
 * the web app in its WebView.
 */
const useIsInWebView = () => {
  const [isInWebView, setIsInWebView] = useState(false);

  useEffect(() => {
    const isAndroidBridgePresent =
      !!window.AndroidBridge?.onAccessTokenReceived;
    const isIosBridgePresent = !!window.webkit?.messageHandlers?.iosBridge;

    const userAgent = window.navigator.userAgent || '';

    // Check for 'wv' or 'Version/x.x' in user agent string
    const isAndroidWebView =
      /Android/i.test(userAgent) && /\bwv\b/.test(userAgent);

    // Check for no 'Safari' in user agent string for iOS device
    const isIosWebView =
      /iPhone|iPad|iPod/i.test(userAgent) && !/Safari/i.test(userAgent);

    setIsInWebView(
      isAndroidBridgePresent ||
        isIosBridgePresent ||
        isAndroidWebView ||
        isIosWebView
    );
  }, []);

  return { isInWebView };
};

export default useIsInWebView;
